export enum CompanyStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  PENDING = 'PENDING',
  DELETED = 'DELETED'
}
